import {DefaultBtn} from "Ncontracts.Common.UI";
import GoogleMap from "../../common/GoogleMap/GoogleMap";
import React, {useEffect, useRef, useState} from "react";
import {imageCdnUrls} from "../../common/ImageCdnUrls";
import {
    storeSelectedContacts,
    contactSelectedList,
    getCommunicationRecipientLocators,
    getAndStoreContactsForRecipientLocations, TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL
} from "../../../actions/communications/newCommunicationAction";
import {useDispatch, useSelector} from "react-redux";
import isEmpty from "../../../helpers/isEmpty";

const ContactsMap = () => {
    const dispatch = useDispatch();
    const googleMapRef = useRef(GoogleMap);
    const [selectedContacts, setSelectedContacts] = useState([]);

    const availableContactLocations = useSelector((state) => state.newCommunication.availableContactLocations);
    const fetching = useSelector((state) => state.newCommunication.fetching);
    const activeMapOverlayId = useSelector((state) => state.mapOverlays.activeMapOverlayId);

    useEffect(() => {
        dispatch(getCommunicationRecipientLocators());
    },[]);

    const clearSelection = () => {
        googleMapRef.current?.clearSelectionPolygon();
        setSelectedContacts([]);
        dispatch(contactSelectedList([]));
    };

    const selectContacts = (selection) => {
        dispatch(contactSelectedList(selection));
        setSelectedContacts(selection);
    };

    const discardMapModal = () => {
        setSelectedContacts([]);
        dispatch(contactSelectedList([]));
        dispatch({type: TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL});
    };

    const submitRecipientSelection = () => {
        const persons = [];
        const locations = [];

        selectedContacts.forEach(item => {
            if (item.contactType === 0) {
                persons.push(item);
            } else if (item.contactType === 1) {
                locations.push(item);
            }
        });
        if (!isEmpty(persons)) {
            dispatch(storeSelectedContacts(persons));
        }
        if (!isEmpty(locations)) {
            dispatch(getAndStoreContactsForRecipientLocations(locations.map(s => s.id)));
        }
        dispatch({type: TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL});
    };

    const mapContactsToMarkers = () => {
        return availableContactLocations.map(contact => {
            return {
                ...contact,
                icon: setMarkerIcon(contact)
            };
        });

        function setMarkerIcon(contact) {
            let icon;
            switch (contact.contactType) {
                case 0:
                    icon = contact.isSelected
                        ? 'map-marker-selected.svg'
                        : 'map-marker-unselected.svg';
                    break;
                case 1:
                    icon = contact.isSelected
                        ? 'comm-office-selected.svg'
                        : 'comm-office-unselected.svg';
                    break;
                default:
                    icon = 'map-marker-unselected.svg';
                    break;
            }
            return imageCdnUrls.map_marker + icon;
        }
    };


    const addButton =
        <DefaultBtn className="btn--solid" onClick={submitRecipientSelection}>Add</DefaultBtn>;

    const discardButton =
        <DefaultBtn className="btn--base" style={{marginRight: '10px'}} onClick={discardMapModal}>Discard</DefaultBtn>;

    const clearButton =
        <DefaultBtn className="clear-button btn--default" onClick={clearSelection}>Clear</DefaultBtn>;

    return (
        <div>
            <div style={{height: '485px', margin: 'auto', borderBottom: '1px solid #E2E2E2'}}>
                {fetching === false &&
                    <GoogleMap
                        ref={googleMapRef}
                        markerList={mapContactsToMarkers()}
                        onSelect={selectContacts}
                        activeMapOverlayId={activeMapOverlayId}
                        useDrawingManager
                    />
                }
            </div>
            <div style={{padding: '25px'}}>
                <div className="is-pulled-left">
                    {clearButton}
                </div>
                <div className="add-button is-pulled-right">
                    {addButton}
                </div>
                <div className="discard-button is-pulled-right">
                    {discardButton}
                </div>
            </div>
        </div>
    );
};

export default ContactsMap;